import { useSteps } from '../../store'
import { StepsInterface } from './interface'

const Steps = ({ children }: StepsInterface): JSX.Element | null => {
  const { step } = useSteps()

  const renderStep = () => {
    const childrens = Array.isArray(children) ? children : [children]
    return childrens[step - 1] || null
  }

  return renderStep()
}

export default Steps
